import {Component, Input, OnInit} from "@angular/core";
import {TeArtefactObjectBaseComponent} from "../te-artefact-object-base.component";
import {TeArtefactDto} from "../../../../../model/dto/entity/te-artefact.dto";

@Component({
    selector: 'te-artefact-object-side',
    templateUrl: './te-artefact-object-side.component.html',
    standalone: false
})

export class TeArtefactObjectSideComponent extends TeArtefactObjectBaseComponent implements OnInit {

    @Input() dto : TeArtefactDto;

    ngOnInit() {
        super.ngOnInit();
    }

}